import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faShieldHalved } from '@fortawesome/pro-solid-svg-icons/faShieldHalved';
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faUserSecret } from '@fortawesome/pro-solid-svg-icons/faUserSecret';
import { ColourStateSolid } from '@ukpostbox/frontend-framework';
import { ChangePassword } from '../Pages/Security/ChangePassword';
import LoginHistory from '../Pages/Security/LoginHistory/Pages/LoginHistory';
import { SubAccounts } from '../Pages/Security/SubAccounts';
import TwoFactor from '../Pages/Security/TwoFactor/Pages/TwoFactor';
import { SuggestibleRouteInterface } from '../../_Global/Types/RouteTypes';

const SecurityRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'Login History',
		path: '/manage-account/security/login-history',
		icon: faUserSecret,
		element: <LoginHistory />,
		colour: ColourStateSolid.Alert,
		group: 'Login & Security',
	},
	{
		title: 'Change Password',
		path: '/manage-account/security/password',
		element: <ChangePassword />,
		icon: faLock,
		colour: ColourStateSolid.Alert,
		group: 'Login & Security',
	},
	{
		title: 'Two Factor _Auth (2FA)',
		path: '/manage-account/security/2fa',
		icon: faShieldHalved,
		element: <TwoFactor />,
		colour: ColourStateSolid.Alert,
		group: 'Login & Security',
	},
	{
		title: 'Sub-Accounts',
		path: '/manage-account/security/sub-accounts',
		element: <SubAccounts />,
		icon: faUsers,
		colour: ColourStateSolid.Alert,
		group: 'Login & Security',
	},
];

export { SecurityRoutes };
